import { createGlobalStyle } from 'styled-components';
import roboto300eot from 'assets/fonts/roboto/roboto-v19-latin-300.eot';
import roboto300woff2 from 'assets/fonts/roboto/roboto-v19-latin-300.woff2';
import roboto300woff from 'assets/fonts/roboto/roboto-v19-latin-300.woff';
import roboto300ttf from 'assets/fonts/roboto/roboto-v19-latin-300.ttf';
import roboto300svg from 'assets/fonts/roboto/roboto-v19-latin-300.svg';

import robotoRegulareot from 'assets/fonts/roboto/roboto-v19-latin-regular.eot';
import robotoRegularwoff2 from 'assets/fonts/roboto/roboto-v19-latin-regular.woff2';
import robotoRegularwoff from 'assets/fonts/roboto/roboto-v19-latin-regular.woff';
import robotoRegularttf from 'assets/fonts/roboto/roboto-v19-latin-regular.ttf';
import robotoRegularsvg from 'assets/fonts/roboto/roboto-v19-latin-regular.svg';

const GlobalFonts = createGlobalStyle`
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 300;
    src: url('${roboto300eot}'); /* IE9 Compat Modes */
    src: local(''),
         url('${roboto300eot}?#iefix') format('embedded-opentype'), /* IE6-IE8 */
         url('${roboto300woff2}') format('woff2'), /* Super Modern Browsers */
         url('${roboto300woff}') format('woff'), /* Modern Browsers */
         url('${roboto300ttf}') format('truetype'), /* Safari, Android, iOS */
         url('${roboto300svg}#Roboto') format('svg'); /* Legacy iOS */
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url('${robotoRegulareot}'); /* IE9 Compat Modes */
    src: local(''),
         url('${robotoRegulareot}?#iefix') format('embedded-opentype'), /* IE6-IE8 */
         url('${robotoRegularwoff2}') format('woff2'), /* Super Modern Browsers */
         url('${robotoRegularwoff}') format('woff'), /* Modern Browsers */
         url('${robotoRegularttf}') format('truetype'), /* Safari, Android, iOS */
         url('${robotoRegularsvg}#Roboto') format('svg'); /* Legacy iOS */
  }
`;

export default GlobalFonts;
